import React from 'react'
import { Tab } from '@atd/rui-base.mui.tab'
import { Tabs } from '@atd/rui-base.mui.tabs'
import MixManager from './mixManager'
import IngredientManager from './ingredientManager'

class ProductManagerTabs extends React.Component {
    state = {
        activeManager: 'mix',
    }

    handleModeChange = (_, manager) => {
        this.setState({activeManager: manager})
    }
    render() {
        const { activeManager } = this.state

        return (
            <div style={{width: '100%', maxWidth: 800, margin: 'auto', paddingBottom: 20}}>
                <Tabs
                    variant="fullWidth"
                    name="productManagerTabs"
                    value={activeManager}
                    onChange={this.handleModeChange}
                >
                    <Tab
                        label="Mixes"
                        value="mix"
                        name="mixManagerTab"
                        sx={{
                            color: '#bdbdbd',
                            backgroundColor: 'var(--secondary)',
                            '&.Mui-selected': {backgroundColor: 'var(--primary)', color: '#fff'},
                        }}
                    />
                    <Tab
                        label="Ingredients"
                        value="ingredient"
                        name="ingredientManagerTab"
                        sx={{
                            borderLeft: 'solid 2px #FFFFFF',
                            color: '#bdbdbd',
                            backgroundColor: 'var(--secondary)',
                            '&.Mui-selected': {backgroundColor: 'var(--primary)', color: '#fff'},
                        }}
                    />
                </Tabs>
                <div style={{marginTop: 15}}>
                    {activeManager === 'mix' && <MixManager/>}
                    {activeManager === 'ingredient' && <IngredientManager/>}
                </div>
            </div>
        )
    }
}

export default (ProductManagerTabs)
